/**
 * @public
 * The size variations for the TableCell component.
 */
export const TableCellSizes = {
    small: "small",
    medium: "medium",
    large: "large"
};
//# sourceMappingURL=table-cell.options.js.map